export default __webpack_public_path__ + "static/media/Netflix3.9898857c.PNG";